var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2V2.5778C15 4.15719 14.5325 5.70126 13.6564 7.0154L11.6667 10L13.6564 12.9846C14.5325 14.2987 15 15.8428 15 17.4222V18C15.5523 18 16 18.4477 16 19C16 19.5523 15.5523 20 15 20H1C0.447715 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18V17.4222C1 15.8428 1.4675 14.2987 2.3436 12.9846L4.33333 10L2.3436 7.0154C1.4675 5.70126 1 4.15719 1 2.5778V2C0.447715 2 0 1.55228 0 1ZM3 18H4.25001L5.456 16.0704C6.63101 14.1904 9.36899 14.1904 10.544 16.0704L11.75 18H13V17.4222C13 16.2377 12.6494 15.0796 11.9923 14.094L9.92963 11H6.07037L4.0077 14.094C3.35063 15.0796 3 16.2377 3 17.4222V18ZM9.3915 18L8.848 17.1304C8.45633 16.5037 7.54367 16.5037 7.152 17.1304L6.60849 18H9.3915ZM3 2H13V2.5778C13 3.41567 12.8246 4.24029 12.4894 5H3.51065C3.17543 4.24029 3 3.41567 3 2.5778V2ZM4.73703 7L6.07037 9H9.92963L11.263 7H4.73703Z",
    fill: "#F15B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderReviewIcon);
export default __webpack_public_path__ + "static/media/under_review_icon.a657147abc4cdfcabfe867bfe8d65553.svg";
export { ForwardRef as ReactComponent };